function sortComments(a, b) {
    return commentScore(b) - commentScore(a);
}

const NEWNESS_WEIGHT = 5;
const NEW_DISLIKE_WEIGHT = 3.5;

function commentScore(comment) {
    let createdAt = new Date(comment.created_at);
    let hoursSinceCreation = Math.round((Date.now() - createdAt.getTime()) / (60 * 60 * 1000));
    let {likes, dislikes} = comment;
    let score = likes - dislikes;
    let newness = (1 / (hoursSinceCreation / 24));

    return (newness * NEWNESS_WEIGHT) + score - (dislikes > 0 ? (dislikes * newness * NEW_DISLIKE_WEIGHT) : 0);
}

module.exports = {
    sortComments,
    commentScore
};
